import {useLocalStorage} from 'platform/components';

import {
  DEFAULT_PHOTO_DOWNLOAD_SIZE_PRESET,
  isPhotoDownloadSizePreset,
  PhotoDownloadSizePreset,
} from '../constants/photoDownloadSizePresets';

const PHOTO_DOWNLOAD_SIZE_PRESET_STORAGE_KEY = 'dms--photo-download-size-preset';

/**
 * The photo download size the user chose last in this browser. A stored value that is not a known
 * preset (an old or edited entry) falls back to the original size.
 */
export function usePhotoDownloadSizePreset() {
  const [storedPreset, setStoredPreset] = useLocalStorage<unknown>(
    PHOTO_DOWNLOAD_SIZE_PRESET_STORAGE_KEY,
    DEFAULT_PHOTO_DOWNLOAD_SIZE_PRESET
  );

  const preset: PhotoDownloadSizePreset = isPhotoDownloadSizePreset(storedPreset)
    ? storedPreset
    : DEFAULT_PHOTO_DOWNLOAD_SIZE_PRESET;

  const setPreset = (nextPreset: PhotoDownloadSizePreset) => setStoredPreset(nextPreset);

  return [preset, setPreset] as const;
}
